<template>
  <div id="launch" class="topopt">

      <b-row>
        <b-col
          sm="4 text-center" v-if="bw_supported >= 1">
          <div class="launchopt">
            <div v-if="$parent.isGuest()">              
             <span> To participate or watch using your <span class="kind">browser</span> please login. </span>
              <span v-if="bw_supported == 1">
                 <span class="support_msg"> {{ support_msg }} </span>
              </span>
              <b-button size="sm" class="launchbtn" variant="vxon"
                @click="$parent.goLogin()"
                >
                Login to Browser
              </b-button>
            </div>
            <div v-if="$parent.isAuth()">
             <span> To participate using your <span class="kind">browser</span> please click continue. </span>
             <span v-if="bw_supported == 1">
                <span class="support_msg"> {{ support_msg }} </span>
             </span>
             <b-button size="sm" class="launchbtn" variant="vxon"
               @click="$parent.getGoLocOrHome()"
               >
                Use Your Browser
             </b-button>
            </div>
          </div>
        </b-col>

        <b-col 
          sm="4 text-center" v-if="bw_supported == 0">
          <div class="launchopt">
            <span> Your browser is not currently supported. You can use <span class="kind">Chrome</span>, <span class="kind">Edge</span>, or <span class="kind">Firefox</span>. For the best experience we recommend using <span class="kind">Chrome</span>. </span>
          </div>
        </b-col>

        <b-col v-if="dl_supported"
          sm="4 text-center">
          <div class="launchopt">
            <span> We have a native app for <span class="kind">{{ dl_plat }}</span>. If you already have it installed, click to the button below. </span>
            <b-button id="launchcheck" variant="vxon"
                size="sm" class="launchbtn"
                @click="launchApp">
                Launch and use the App
            </b-button>
          </div>
        </b-col>

        <b-col v-if="dl_supported"
           sm="4 text-center">
           <div  class="launchopt">
            <span> If you need to install the <span class="kind">{{ dl_plat }}</span> app, you can download it below. </span>
             <iframe v-if="dl_iframe" class="launchbtn downif"
               scrolling="no" frameBorder="0"
               allowTransparency="true"
               :src=dl_url
             >
             </iframe>
            <b-button v-if="!dl_iframe" id="launchcheck" variant="vxon"
                size="sm" class="launchbtn"
                :href="dl_url">
                {{ dl_msg  }}
            </b-button>
          </div>
        </b-col>

        <b-col v-if="pwa_supported"
           sm="4 text-center">
           <div  class="launchopt">
            <div> Install our <span class="kind">Progressive Web App</span>. </div>
            <div style="margin-top:1rem; color:#777777;"> Installation is not possible if you already have the App installed or are in Incognito/Private browser mode. </div>
            <b-button size="sm" class="launchbtn" variant="vxon"
               @click="pwaInstall"
               :disabled="!pwaReady"
               >
               Web App Install
            </b-button>
          </div>
        </b-col>
      </b-row>

      <div v-if="false" style="padding: 1rem 5vw;">
        <div> Your Platform {{ raw_plat }} </div>
        <div> Your UA {{ raw_ua }} </div>
      </div>
      
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "download",
  data() {
    return {
      raw_plat: "",
      raw_ua: "",
      dl_plat: "",
      dl_msg:  "",
      dl_url: "",
      dl_supported: false,
      dl_iframe: false,
      dl_show: true,
      pwa_supported: false,
      launch_proto: "",
      bw_supported: -1,
      pwaReady: false,
    }
  },
  components: {
  },
  created() {
  },
  methods: {
    launchApp: function(ev) {
       let vue = this;
       if (!vue.launch_proto) { return; }
       if (vue.desktop) {
         window.try_launch_app(""+vue.launch_proto + window.location.host,
           function(w) {
             setTimeout(function() {
                 w.document.write('<html> <body> <script> window.alert("If the app did not launch you may not have installed it"); window.close(); <\/script> <\/body> <\/html>');           
             }, 1000);
             setTimeout(function() {
                w.close();
             }, 5000);
          });
       } else {
         window.try_launch_app("" + vue.launch_proto + window.location.host+"/mm/");
       }
    },
    pwaInstall: function() {
      console.log("Button Deferred PWA:",window.deferredPWAPrompt);
      if (!window.deferredPWAPrompt) { return; }
      window.deferredPWAPrompt.prompt();
    }
  },
  computed: {
  },
  mounted() {
    let vue = this;
    let plat = window.navigator.platform;
    let ua = window.navigator.userAgent.toLowerCase();
    vue.raw_plat = plat;
    vue.raw_ua = ua;
    if (/macintel/i.test(plat) && window.navigator.maxTouchPoints > 1) {
       /* iOS 14.4 iPad platform bug */
       plat = "iPad";
    }
    if (/Mac/i.test(plat)) {
      vue.dl_plat = "Mac";
      vue.dl_msg = "Download for Mac";
      vue.dl_url = "https://s3.us-east-1.amazonaws.com/videocafe.live/download_button_mac.html";
      vue.dl_supported = true;
      vue.dl_iframe = true;
      vue.desktop = true;
      vue.launch_proto = "vxstreamer://";
    } else if (/(Win32|Win64)/i.test(plat)) {
      vue.dl_plat = "Windows";
      vue.dl_msg = "Download for Windows";
      vue.dl_url = "https://s3.us-east-1.amazonaws.com/videocafe.live/download_button_win.html";
      vue.dl_supported = true;
      vue.dl_iframe = true;
      vue.launch_proto = "vxstreamer://";
      vue.desktop = true;
    } else if (/(iPhone|iPod|iPad)/i.test(plat)) {
      vue.dl_plat = "iOS";
      vue.dl_msg = "Get from the Apple App Store";
      vue.dl_url = "https://apps.apple.com/us/app/videocafe/id1503732487";
      vue.dl_supported = true;
      vue.dl_iframe = false;
      vue.launch_proto = "vxstreamer://";
      vue.desktop = false;
    } else if (ua.indexOf("android") > -1) {    
      vue.dl_plat = "Android";
      vue.dl_msg = "Get from the Google Play Store";
      vue.dl_url = "https://play.google.com/store/apps/details?id=com.vuemix.videocafe";
      vue.dl_supported = true;
      vue.dl_iframe = false;
      vue.launch_proto = "vxstreamer://";
      vue.desktop = false;
    } else {
      vue.dl_plat = "Other";
      vue.dl_msg = "We don't have a native app for your platform";
      vue.dl_url = null;
      vue.dl_supported = false;
      vue.launch_proto = null;
      vue.desktop = true;
    }

    if (vue.desktop) {
      if (window.vx.about.is_chrome ||
          window.vx.about.is_edge) {
          vue.bw_supported = 2;
          vue.dl_supported = false;
          vue.pwa_supported = true;
      } else if (window.vx.about.is_firefox) {
          vue.bw_supported = 2;
          /*  vue.support_msg = "For the best browser experience we recommend using Chrome."; */
      } else if (window.vx.about.is_safari) {
          vue.bw_supported = 1;
          vue.support_msg = "Safari Users: We recommend using Chrome for the best experience.";
      } else if (window.vx.staging) {
          vue.bw_supported = 1;
          vue.support_msg = "This browser only allowed on staging.";
      } else {
          vue.bw_supported = 0;
          vue.$parent.nav.goloc_cont = false;
          vue.$parent.nav.login = false;
      }
      if (vue.bw_supported) {
         window.setLocal("vx_download_shown",true);
      }
    } else if (false && window.vx.staging) {
      vue.bw_supported = 1;
      vue.support_msg = "This Non-Desktop only allowed on staging";
    } else {
      vue.bw_supported = -1;
      vue.$parent.nav.goloc_cont = false;
      vue.$parent.nav.login = false;
    }

    if (vue.$parent.mydevice.is_pwa) {
       vue.$parent.goLogin();
       return;
    }

    window.vx.download_wait = false;
    vue.pwa_tid = setInterval(function() {
       if (!window.deferredPWAPrompt) { return; }
       if (window.installedPWA) {
          // Fresh PWA Install
          clearTimeout(vue.pwa_tid);
          vue.pwaReady = false;
          vue.$parent.mydevice.is_pwa = true;
          vue.$parent.goLogin();
          return;
       }
       vue.pwaReady = true;
    }, 500);
  },
  beforeDestroy() {
    let vue = this;
    window.clearTimeout(vue.pwa_tid);
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 760px;
}

.topopt {
  margin: 3rem 1rem;  
}

.launchopt {
  position:relative;
  min-height: 225px;
  background-color: #e0e0e0;
  border: solid black 2px;
  border-radius: 1rem;
  padding: 0.5rem 0.5rem 0 0.5rem;
}

.launchbtn {
  margin:0 0.1rem;
  width: calc(100% - 1rem);
  position: absolute;
  bottom:0.5rem;
  left:0.5rem;
}

.downif {
  background-color: transparent;
  margin:0;
  padding:0;
  border-radius: 0.5rem;
  max-height: 150px;
}

@media screen and (max-width:600px) and (orientation:portrait) {
  .launchopt {
    min-height: 150px;
  }
  .downif {
    max-height: 100px;
  }
}

.kind {
 font-weight: 600;
 text-decoration: underline;
}

.support_msg {
 font-weight: 600;
 color: rgb(150,50,50);
}

 .btn.disabled {
   cursor: not-allowed;
 }
</style>
